import createModule from "./wasm/engine.js";
import binary from "./wasm/binary.js";
import createWasmDb from "./wasmDb.js";

export default (app) => {
  let module;
  try {
    module = new WebAssembly.Module(Uint8Array.from(atob(binary), (char) => char.charCodeAt(0)));
  } catch (error) {
    console.error("Unable to load the Wasm memory database.", error);
    return;
  }

  app.database.on(
    "init",
    ({ contentType }) => {
      if (!["eventStorageFileWasm", "debounceStorageFileWasm"].includes(contentType.storage)) return;

      const { initSync, MemoryDb } = createModule();
      initSync({ module });
      const db = { wasm: new MemoryDb() };
      const collection = app.addeventhandler(
        { contentType },
        ["aggregate", "delete", "find", "get", "init", "save", "saveFile", "search", "size", "update", "updates"],
        `wasm database ${contentType.machinename}`,
      );

      createWasmDb(app, collection, db, contentType);
      return { collection, db, contentType, inited: true, memdb: false };
    },
    1001,
  );
};
